<template>
  <vx-card no-shadow>

    <ValidationObserver ref="form" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(onClickSubmit)" autocomplete="off">

<!--        <vs-divider class="mt-8 mb-12" color="primary" position="center">Genaral Informations</vs-divider>-->

        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <ValidationProvider vid="appearance" name="appearance" rules="required" v-slot="{ errors }">
              <small class="label">Appearance</small>
              <vs-input :disabled="__isDisabledRawMaterial(status)" type="text" v-model="form.appearance" name="appearance" class="w-full"  :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <ValidationProvider vid="colour" name="colour" rules="required" v-slot="{ errors }">
              <small class="label">Colour</small>
              <vs-input :disabled="__isDisabledRawMaterial(status)" type="text" v-model="form.colour" name="colour" class="w-full"  :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
            </ValidationProvider>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <ValidationProvider vid="texture" name="texture" rules="required" v-slot="{ errors }">
              <small class="label">Form</small>
              <v-select  :disabled="__isDisabledRawMaterial(status)" name="raw_material_stage" :closeOnSelect="true" v-model="form.texture" :options="['liquid', 'powder', 'paste']" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
              <span class="text-danger text-sm">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <ValidationProvider vid="moisture_context" name="moisture_context" rules="required" v-slot="{ errors }">
              <small class="label">Moisture Content</small>
              <vs-input :disabled="__isDisabledRawMaterial(status)" type="text" v-model="form.moisture_context" name="moisture_context" class="w-full"  :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
            </ValidationProvider>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <ValidationProvider vid="refractive_index" name="refractive_index" :rules="form.texture !== 'liquid' ? 'required' : ''" v-slot="{ errors }">
              <small class="label">Refractive Index</small>
              <vs-input :disabled="__isDisabledRawMaterial(status)" type="text" v-model="form.refractive_index" name="refractive_index" class="w-full"  :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <ValidationProvider vid="refractive_index_temp" name="refractive_index_temp" :rules="form.texture !== 'liquid' ? 'required' : ''" v-slot="{ errors }">
              <small class="label">Temperature (⁰C)</small>
              <vs-input :disabled="__isDisabledRawMaterial(status)" type="text" v-model="form.refractive_index_temp" name="refractive_index_temp" class="w-full"  :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
            </ValidationProvider>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <ValidationProvider vid="specific_gravity" name="specific_gravity" :rules="form.texture !== 'liquid' ? 'required' : ''" v-slot="{ errors }">
              <small class="label">Specific Gravity</small>
              <vs-input :disabled="__isDisabledRawMaterial(status)" type="text" v-model="form.specific_gravity" name="specific_gravity" class="w-full"  :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <ValidationProvider vid="specific_gravity_temp" name="specific_gravity_temp" :rules="form.texture !== 'liquid' ? 'required' : ''" v-slot="{ errors }">
              <small class="label">Temperature (⁰C)</small>
              <vs-input :disabled="__isDisabledRawMaterial(status)" type="text" v-model="form.specific_gravity_temp" name="specific_gravity_temp" class="w-full"  :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
            </ValidationProvider>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col md:w-full md:mb-0">
            <ValidationProvider vid="is_others" name="is_others" rules="" v-slot="{ errors }">
              <small class="label">Other</small>
              <vs-switch :disabled="__isDisabledRawMaterial(status)" v-model="form.is_others" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
        </div>

        <div  v-for="(other, index) in is_others_data" :key="index" v-if="form.is_others" >
          <div class="vx-row mb-3">
            <div class="vx-col md:w-2/5 w-full md:mb-0">
              <ValidationProvider :vid="index+'name'" :name="index+'name'" rules="required" v-slot="{ errors }">
                <small class="label">Name</small>
                <vs-input :disabled="__isDisabledRawMaterial(status)" type="text" name="is_document_vulnerability_text" class="w-full" v-model="other.name" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-2/5 w-full md:mb-0">
              <ValidationProvider :vid="index+'temp'" :name="index+'temp'" rules="required" v-slot="{ errors }">
                <small class="label">Temperature (⁰C)</small>
                <vs-input :disabled="__isDisabledRawMaterial(status)" type="text" name="is_document_vulnerability_text" class="w-full" v-model="other.temp" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
            <div class="vx-col w-1/5">
              <vs-button color="danger" icon="delete"  @click="deleteOthers(index)" type="border" class="ml-auto mt-6 w-full" >Delete</vs-button>
            </div>
          </div>
        </div>
        <vs-button v-if="form.is_others"  @click="addOther" size="small" color="primary" type="filled" icon-pack="feather" icon="icon-plus">Add</vs-button>


        <div class="flex flex-wrap items-center justify-end">
          <vs-button v-if="status.is_raw_material_p_c_s_parameter_complete"  button="submit" class="ml-auto mt-2" :disabled="__isDisabledRawMaterial(status)">Save Changes</vs-button>
          <vs-button v-else button="submit" class="mt-2 ml-4" :disabled="__isDisabledRawMaterial(status)">Save Changes</vs-button>
        </div>
      </form>
    </ValidationObserver>
  </vx-card>

</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture')
  const SupplierRawMaterialRepository = RepositoryFactory.get('supplierRawMaterial')

  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import vSelect from "vue-select";

    export default {
        name: "SupplierManufacturingHome",
      data() {
          return {
            form: {
              is_others: false
            },
            id: null,
            status: {},
            is_others_data:[{
              name: '',
              temp: ''
            }]
          }
      },
      components: {
        'v-select': vSelect
      },
      mixins: [SuccessMessage, ErrorMessages],
      methods: {
        onClickNext() {
          this.$emit('notify', 1)
        },
        onClickSubmit() {
          this.status.is_raw_material_p_c_s_parameter_complete ? this.onClickUpdate() : this.onClickCreate()
        },

        async onClickUpdate() {
          this.$vs.loading()
          try {
            if (!this.form.is_others) {
              this.form.is_others_data = []
            } else {
              this.form.is_others_data = this.is_others_data
            }
            const data= (await SupplierRawMaterialRepository.UpdateRawMaterialPCSParameters(this.id, this.form))
            this.showSuccessMessage('Raw Material PCS Parameter Details Updated!')
            this.onClickNext()
          }catch (e) {
            this.convertAndNotifyError(e)
          }
          this.$vs.loading.close()
        },
        async onClickCreate() {
          this.$vs.loading()
          try {
            if (!this.form.is_others) {
              this.form.is_others_data = []
            } else {
              this.form.is_others_data = this.is_others_data
            }
            const data= (await SupplierRawMaterialRepository.CreateRawMaterialPCSParameters(this.form))
            this.showSuccessMessage('Raw Material PCS Parameter Details Created!')
            this.onClickNext()
          }catch (e) {
            this.convertAndNotifyError(e)
          }
          this.$vs.loading.close()
        },

        async loadData() {
          this.$vs.loading()
          const {data} = (await SupplierRawMaterialRepository.getRawMaterialPCSParameters(this.id)).data
          this.form =data
          this.is_others_data = this.form.is_others_data
          this.$vs.loading.close()
        },
        async loadStatus() {
          this.$vs.loading()
          const {data} = (await SupplierRawMaterialRepository.getRawMaterialStatus(this.id)).data
          this.status =data
          this.$vs.loading.close()
        },
        addOther() {
          this.is_others_data.push({
            name: '',
            temp: ''
          })
        },
        deleteOthers(index) {
          this.is_others_data.splice(index, 1)
        }
      },
      async mounted() {
        this.id = this.$route.params.id
        this.form.supplier_raw_material_id =  this.id
        await this.loadStatus()
        if (this.status.is_raw_material_p_c_s_parameter_complete ) {
          await this.loadData()
        }
      }
    }
</script>

<style scoped>

</style>
